import { useRouteResponse } from "@src/app/hooks/useRouteResponse";

import OptimisedImage from "../OptimisedImage/OptimisedImage";
import ArticleImageCaption from "./body/ArticleImageCaption";

function withEnableJsApi(url: string): string {
  if (!url) return url;
  if (url.includes("enablejsapi=1")) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}enablejsapi=1`;
}

export default function ArticleMainMedia() {
  const { article } = useRouteResponse("articlePage");

  const articleMainMedia = article?.mainMedia || [];
  if (!articleMainMedia.length) return null;

  const video = articleMainMedia.find((i) => i.type === "youtube_video");

  if (video) {
    return (
      <iframe
        className="aspect-3/2 w-full pb-4"
        src={withEnableJsApi(video.url)}
        title={video.title}
        allowFullScreen
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
      />
    );
  }

  const images = articleMainMedia.filter((i) => i.type === "image");
  if (!images.length) return null;

  const image = images[0];

  return (
    <figure className="w-full px-3 pb-4">
      <OptimisedImage
        filters={{
          lg: { f: "webp", w: 720, q: 80, dpr: 3 },
          md: { f: "webp", w: 720, q: 80, dpr: 3 },
          sm: { f: "webp", w: 360, q: 80, dpr: 3 },
        }}
        rootClassName="w-full"
        src={image.url}
        alt={image.altText || image.caption}
        {...{ fetchpriority: "high" }}
      />
      <ArticleImageCaption element={image} />
    </figure>
  );
}
